import { cn } from "@/lib/utils";

export function DownIcon({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-[9px] w-4 text-white", className)}
      viewBox="0 0 16 9"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.933.39L7.63 5.564 2.327.39A1.385 1.385 0 00.4.39a1.305 1.305 0 000 1.88l6.273 6.12c.533.52 1.394.52 1.927 0l6.274-6.12c.533-.52.533-1.36 0-1.88-.534-.507-1.408-.52-1.941 0z"
        fill="currentColor"
      />
    </svg>
  );
}

export function PlayedIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-4.5 text-teal transition-colors", className)}
      viewBox="0 0 18 18"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M0 9c0-4.968 4.032-9 9-9s9 4.032 9 9-4.032 9-9 9-9-4.032-9-9zm3.33.63l3.231 3.231a.896.896 0 001.27 0l6.83-6.83a.896.896 0 10-1.269-1.27L7.2 10.953 4.6 8.361a.896.896 0 10-1.27 1.27z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}

export function WishlistIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-4.5 w-3.5 text-berry transition-colors", className)}
      viewBox="0 0 14 18"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 2a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.6L0 18V2z"
        fill="currentColor"
      />
    </svg>
  );
}
